import { alsTag, langTag } from './rastertage.ts';
/**
 * WIE EINE VERSION FÜR EINEN MENSCHEN HEISST.
 *
 * ORIGINALTEXT MARVIN (05.09.2026)
 *   „die version musst du vom format was anpassen, denn da steht ja noch ein
 *    datum drin und das passt ja so garnicht. mache nur die versionsnummer
 *    und wann es eingespielt wurde."
 *
 * Unten links stand `2026-08-26.112`. Das Datum darin ist der Tag, an dem
 * die REIHE begonnen hat - es ändert sich seit dem 26.08.2026 nicht mehr und
 * sagt über diese Version nichts. **Eine Angabe, die aussieht wie ein Datum
 * und keines ist, wird gelesen wie eines**, und dann hält jemand eine
 * Lieferung von gestern für zwei Wochen alt.
 *
 * ES IST DIESELBE TRENNUNG WIE ÜBERALL IN DIESEM HAUS: der BEZEICHNER bleibt,
 * wie er ist, und daneben steht der TEXT für Menschen.
 *
 * ```
 *   lieferung.json     "nummer": "2026-08-26.112"   die Kennung der Lieferung
 *   changelog.version  '2026-08-26.112'             der Bezug auf sie
 *   auf dem Bildschirm  Version 112                 was ein Mensch liest
 * ```
 *
 * Die Datei anzufassen wäre der teurere Weg gewesen: an dieser Zeichenkette
 * hängen `packen.sh`, die Merkmale des Servers und jede Zeile des
 * Änderungsverzeichnisses. **Wer eine Kennung umbenennt, benennt sie überall
 * um** - und hier ist gar keine Kennung falsch, sondern nur ihre Anzeige.
 *
 * DIESE DATEI TRÄGT KEIN JSX, und das ist Absicht: eine Datei mit JSX lässt
 * sich mit `--experimental-strip-types` nicht laden, und dann bliebe einem
 * Prüfstand nur die Textsuche. Achte Datei dieser Art.
 */

/**
 * Die Versionsnummer aus der Kennung der Lieferung.
 *
 * `2026-08-26.112` wird `112`. Was keinen Punkt trägt, bleibt, wie es ist -
 * **eine Kennung, die anders gebaut ist als erwartet, wird nicht
 * zurechtgeschnitten, sondern gezeigt**, sonst steht dort irgendwann eine
 * leere Zeile statt einer Auskunft.
 */
export function versionsnummer(nummer: string | null | undefined): string {
  const s = String(nummer ?? '').trim();
  if (!s) return 'unbekannt';
  const punkt = s.lastIndexOf('.');
  if (punkt < 0 || punkt === s.length - 1) return s;
  const hinten = s.slice(punkt + 1);
  return /^\d+$/.test(hinten) ? hinten : s;
}

/**
 * Und wann sie eingespielt wurde, als Satz.
 *
 * **DEUTSCH, TT.MM.JJJJ** - dieselbe Regel wie überall, wo ein Mensch liest.
 * Ohne Angabe steht der halbe Satz gar nicht erst da: „eingespielt am -" ist
 * eine Zeile über eine Lücke.
 */
export function eingespieltText(wann: string | null | undefined): string {
  if (!wann) return '';
  /* IN DER ZEIT DES BETRIEBS UND NICHT IN DER DES BETRACHTERS. Hier standen
     die lokalen Getter: wer in Zypern kurz nach Mitternacht nachsieht, las
     das Einspieldatum einen Tag zu spaet. Dieselbe Falle wie im Wochenplan,
     nur billiger - und deshalb ist sie so lange stehengeblieben. */
  const t = alsTag(wann);
  return t ? langTag(t) : '';
}
